// import BsDidaSdk from './../bs-didasdk';
import bsGetEnv from '../BsGetEnv';
class WaitTime {
    constructor(send) {
        this.name = 'WaitTime';
        this.trakData = null;
        // 加载页面初始化时间
        this.startTime = new Date().getTime();
        // 默认defaultData
        this.defaultData = {};
        // 上至上报actions
        this.waitTimeName = 'h5_leave_page'
    }
    // 初始化
    init(send){
        try {
            this.send = send;
            if(bsGetEnv.inApplication){
                if(!window.DIDASDK){
                    console.log('DIDASDK没有引入！');
                    return;
                } 
                window.DIDASDK.invoke('closeWebviewCallBack',() => {
                    this.sendWaitTime();
                })
            }
            // this.proxyXhr();
            this.controlPageChanged();
        } catch (error) {
            console.log(error);
        }
        
    }
    // 上报页面停留时间
    sendWaitTime(){
        try {
            let waitTime = new Date().getTime() - this.startTime;
            this.send(this.waitTimeName, {
                waitTime
            })
            this.startTime = new Date().getTime();
        } catch (error) {
            console.log(error);
        }
        
    }
    // 监控页面进入后台
    controlPageChanged(){
        try {
            document.addEventListener('visibilitychange', ()=> {
                if(document.visibilityState === 'hidden'){
                    // 页面处于不可见状态
                    // 记录结束时间 endTime
                    this.sendWaitTime();
                }else if(document.visibilityState === 'visible'){
                    // 页面处于可见状态
                    // 记录开始时间 startTime
                    this.startTime = new Date().getTime();
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    getWaitTimeName(name){
        try {
            // this.defaultData = data || {};
            name && (this.waitTimeName = name);
        } catch (error) {
            console.log(error);
        }
    }
}
export default new WaitTime();
